import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Switch, Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// pages
import LoginScreen from './../screens/Login';
import InteractiveMapScreen from './../screens/InteractiveMap';
import SubmitDataScreen from './../screens/SubmitData';

import ProtectedRoute from './ProtectedRoute';
import Layout from './../components/Layout';

const withLayout = Child => {
  const WrappedComponent = props => (
    <Layout>
      <Child {...props} />
    </Layout>
  );

  return WrappedComponent;
};

@inject('userStore', 'commonStore')
@withRouter
@observer
class Routes extends Component {
  static propTypes = {
    commonStore: PropTypes.object.isRequired,
    userStore: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };
  componentWillMount() {
    if (!this.props.commonStore.token) {
      this.props.commonStore.setAppLoaded();
    }
  }

  componentDidMount() {
    if (this.props.commonStore.token) {
      this.props.userStore
        .updateSelf()
        .catch(() => this.props.commonStore.setToken(undefined))
        .finally(() => this.props.commonStore.setAppLoaded());
    }
  }
  render() {
    if (this.props.commonStore.isAppLoaded) {
      // token is present but user is not loaded yet
      this.props.commonStore.setCurrentRoute(this.props.location.pathname);
      return (
        <Switch>
          <Route path="/login" component={LoginScreen} />
          <Route exact path="/" component={withLayout(InteractiveMapScreen)} />
          <ProtectedRoute path="/submit-data" component={withLayout(SubmitDataScreen)} />
        </Switch>
      );
    }
    return (
      <div style={{ width: '100vh', height: '100vh' }} className="lds-double-ring">
        <div />
        <div />
      </div>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js